import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MobileMenu from '../base/Navi/mobileMenu';
import naviData from '../../data/navi/naviLinkItem.json';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { withUtm } from 'helpers/tracking';
import { isPlainLink, isCurrentPage as isCurrent } from 'helpers/navi';

/**
 * The site's main menu, from data/navi/naviLinkItem.json: a group with one
 * entry named like the group is a plain link ("Overview"); any other group
 * is a dropdown. Every link carries the visit's campaign params (utm_*,
 * click ids) forward, so a paid visitor is still one after they navigate.
 * The entry for the page the visitor is on is marked .active (its
 * dropdown too), which the stylesheet highlights.
 */
const HeaderNavigation = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { pathname, search } = useLocation();

  if (!naviData) return null;

  if (isMobile) {
    return <MobileMenu />;
  }
  return (
    <nav className="site-main-menu">
      <ul>
        {naviData.map((item, i) => {
          if (!isPlainLink(item)) {
            const open = item.list.some((listItem) => isCurrent(pathname, listItem.url, search));
            return (
              <li key={`nav-${item.id}-${i}`} className={`has-children${open ? ' active' : ''}`}>
                {/* a plain anchor, not a NavLink: a NavLink to "#" resolves to
                    the current page and would light every dropdown at once */}
                <a href="#" onClick={(e) => e.preventDefault()} aria-haspopup="true">
                  <span className="menu-text">
                    {item.title}
                    <KeyboardArrowDownIcon
                      fontSize=""
                      sx={{ pl: 0.3, mt: 0.3 }}
                    />
                  </span>
                </a>
                <ul className="sub-menu">
                  {item.list.map((listItem, i) => (
                    <li key={`subnav-${listItem.id}-${i}`} className={isCurrent(pathname, listItem.url, search) ? 'active' : undefined}>
                      <Link
                        to={withUtm(listItem.url, search)}
                        target={listItem.outSource ? '_blank' : ''}
                        rel="noopener noreferrer"
                        aria-current={isCurrent(pathname, listItem.url, search) ? 'page' : undefined}
                      >
                        {listItem.text}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            )
          }

          const [only] = item.list;
          return (
            <li key={i}>
              {/* its own current-page test, not NavLink's: ?persona= makes a different page of the same path */}
              <Link
                to={withUtm(only.url, search)}
                target={only.outSource ? '_blank' : ''}
                rel="noopener noreferrer"
                className={isCurrent(pathname, only.url, search) ? 'active' : undefined}
                aria-current={isCurrent(pathname, only.url, search) ? 'page' : undefined}
              >
                {item.title}
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

export default HeaderNavigation;
